module.exports = __webpack_public_path__ + "static/media/map-de.7c6b1e38.jpg";